import CompanyRangeChart from './CompanyRangeChart'

export default CompanyRangeChart
